'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRedux = require('react-redux');

var _reselect = require('reselect');

var _userUtil = require('../../userUtil');

var _currentUserSelector = require('../../currentUserSelector');

var _teamManagementActions = require('../team/teamManagementActions');

var _UpgradePlan = require('./upgrade/UpgradePlan');

var _UpgradePlan2 = _interopRequireDefault(_UpgradePlan);

var _PlanPro = require('./pro/PlanPro');

var _PlanPro2 = _interopRequireDefault(_PlanPro);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var planSelector = (0, _reselect.createStructuredSelector)({
    currentUser: _currentUserSelector.getCurrentUser,
    isSubscriptionAdmin: _currentUserSelector.currentUserIsSubscriptionAdminSelector,
    subscription: _currentUserSelector.getCurrentUserSubscription,
    subscriptionDetail: _currentUserSelector.getCurrentUserSubscriptionDetail,
    subscriptionTeam: _currentUserSelector.subscriptionTeamSelector,
    customer: _currentUserSelector.getCurrentUserCustomer,
    subscriptionAdminUser: _currentUserSelector.subscriptionAdminUserSelector
});

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
    return {
        revertTeamList: function revertTeamList(userIds) {
            return dispatch((0, _teamManagementActions.setTeamMembers)({ userIds: userIds }));
        }
    };
};

var CurrentPlan = function (_React$Component) {
    _inherits(CurrentPlan, _React$Component);

    function CurrentPlan() {
        _classCallCheck(this, CurrentPlan);

        return _possibleConstructorReturn(this, (CurrentPlan.__proto__ || Object.getPrototypeOf(CurrentPlan)).apply(this, arguments));
    }

    _createClass(CurrentPlan, [{
        key: 'componentWillMount',
        value: function componentWillMount() {
            var _props = this.props,
                currentUser = _props.currentUser,
                subscription = _props.subscription,
                revertTeamList = _props.revertTeamList;


            var userIds = subscription && subscription.get('teamMemberIds') ? subscription.get('teamMemberIds').toArray() : [currentUser.get('_id')];

            revertTeamList(userIds);
        }
    }, {
        key: 'render',
        value: function render() {
            if ((0, _userUtil.isSubscribed)(this.props.currentUser)) return _react2.default.createElement(_PlanPro2.default, this.props);
            return _react2.default.createElement(_UpgradePlan2.default, this.props);
        }
    }]);

    return CurrentPlan;
}(_react2.default.Component);

CurrentPlan.propTypes = {
    currentUser: _propTypes2.default.object,
    subscription: _propTypes2.default.object,
    revertTeamList: _propTypes2.default.func
};

exports.default = (0, _reactRedux.connect)(planSelector, mapDispatchToProps)(CurrentPlan);


//////////////////
// WEBPACK FOOTER
// ./src/client/user/account/plan/CurrentPlan.js
// module id = 2067
// module chunks = 0